import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  submit: {
    textTransform: 'none',
    height: '50px',
    fontSize: '17px',
    margin: theme.spacing(3, 0, 2),
  },
}))